import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
import { useLanguage } from "../contexts/LanguageContext"

const query = graphql`
  {
    file(relativePath: { eq: "rsz_gdje-je-pečat_1.png" }) {
      childImageSharp {
        fixed {
          ...GatsbyImageSharpFixed
        }
      }
    }
    otherFile: file(relativePath: { eq: "output-onlinepngtools.png" }) {
      childImageSharp {
        fixed {
          ...GatsbyImageSharpFixed
        }
      }
    }
    euLogo: file(
      relativePath: {
        eq: "HR Financira Europska unija - NextGenerationEU_POS_POS.png"
      }
    ) {
      childImageSharp {
        fixed(width: 300) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`
const Footer = () => {
  const data = useStaticQuery(query)
  const { selectedLanguage } = useLanguage() // Use the useLanguage hook 
  return (
    <footer className="footer">
      <div>
        <div>
          {selectedLanguage === "EN" ? (
            <p>
              Osijek-Koteks d.d. • Šamačka 11, 31000 Osijek • Tel. +385 (0)31 22
              77 00 • OIB:44610694500 • uprava@osijek-koteks.hr | Agram banka
              d.d.
            </p>
          ) : (
            <p>
              Osijek-Koteks d.d. • Šamačka 11, 31000 Osijek • Tel. +385 (0)31 22
              77 00 • OIB:44610694500 • uprava@osijek-koteks.hr | Agram banka
              d.d.
            </p>
          )}
        </div>
      </div>
      <div>
        <p>IBAN: HR38 248 10001123001112 SWIFT: KREZHR2X</p>
      </div>
      <div>
        {selectedLanguage === "EN" ? (
          <p>
            Osijek-Koteks &copy; {new Date().getFullYear()} All rights reserved
          </p>
        ) : (
          <p>
            Osijek-Koteks &copy; {new Date().getFullYear()} Sva prava pridržana
          </p>
        )}
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "2rem", padding: "0.5rem 0 2rem 0", marginLeft: "4rem" }}>
        <style>{`
          @media (max-width: 768px) {
            .footer-icons-container {
              display: none !important;
            }
          }
        `}</style>
        <div className="footer-icons-container">
          <Image
            fixed={data.file.childImageSharp.fixed}
          />
        </div>
        <div className="footer-icons-container">
          <Image
            fixed={data.otherFile.childImageSharp.fixed}
          />
        </div>
        <div className="footer-icons-container">
          <Image
            fixed={data.euLogo.childImageSharp.fixed}
          />
        </div>
      </div>
    </footer>
  )
}

export default Footer
